import api from '../../services/api';
import { QUERY } from '../../constants/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getCalendarData = createAsyncThunk(QUERY, async () => {
  try {
    const response = await api.get(QUERY);
    return response.data;
  } catch (error) {
    return error.message;
  }
});
